import {findIndex} from 'lodash';

const state = {
  list: null,
  step: 1,
  template: null,
}

const mutations = {
  reset(state) {
    state.list = null;
    state.step = 1;
    state.template = null;
  },
  setList(state, list) {
    state.list = list;
  },
  setStep(state, step) {
    state.step = step;
  },
  setTemplate(state, template) {
    state.template = template;
  }
}

const getters = {
  cart: state => state,
  list: state => state.list,
  step: state => state.step,
  template: state => state.template,
}

const actions = {
  reset({commit}) {
    commit('reset');
  },
  setList({commit}, list) {
    commit('setList', list)
  },
  setStep({commit}, step) {
    commit('setStep', step);
  },
  prevStep({commit, getters}) {
    if (getters.step > 1) {
      commit('setStep', getters.step - 1);
    }
  },
  nextStep({commit, getters}) {
    if (getters.step < 3) {
      commit('setStep', getters.step + 1);
    }
  },
  setTemplate({commit}, template) {
    commit('setTemplate', template);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
